// source: proto/accountpb/client.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
var proto_accountpb_owner_pb = require('../../proto/accountpb/owner_pb.js');
goog.object.extend(proto, proto_accountpb_owner_pb);
var proto_accountpb_address_pb = require('../../proto/accountpb/address_pb.js');
goog.object.extend(proto, proto_accountpb_address_pb);
var proto_accountpb_contactinfo_pb = require('../../proto/accountpb/contactinfo_pb.js');
goog.object.extend(proto, proto_accountpb_contactinfo_pb);
var proto_accountpb_identification_pb = require('../../proto/accountpb/identification_pb.js');
goog.object.extend(proto, proto_accountpb_identification_pb);
var proto_accountpb_note_pb = require('../../proto/accountpb/note_pb.js');
goog.object.extend(proto, proto_accountpb_note_pb);
var proto_accountpb_subaccount_pb = require('../../proto/accountpb/subaccount_pb.js');
goog.object.extend(proto, proto_accountpb_subaccount_pb);
var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js');
goog.object.extend(proto, proto_utilspb_pagination_pb);
goog.exportSymbol('proto.accountpb.Client', null, global);
goog.exportSymbol('proto.accountpb.EmptyRequest', null, global);
goog.exportSymbol('proto.accountpb.GetAccountIdResponse', null, global);
goog.exportSymbol('proto.accountpb.GetAccountInfoRequest', null, global);
goog.exportSymbol('proto.accountpb.GetAccountInfoResponse', null, global);
goog.exportSymbol('proto.accountpb.GetUserAccountIdRequest', null, global);
goog.exportSymbol('proto.accountpb.ListClientRequest', null, global);
goog.exportSymbol('proto.accountpb.ListClientResponse', null, global);
goog.exportSymbol('proto.accountpb.ListSelectionItemResponse', null, global);
goog.exportSymbol('proto.accountpb.ListSubAccountTypeItemRequest', null, global);
goog.exportSymbol('proto.accountpb.ReadClientByUserRequest', null, global);
goog.exportSymbol('proto.accountpb.ReadClientRequest', null, global);
goog.exportSymbol('proto.accountpb.ReadClientResponse', null, global);
goog.exportSymbol('proto.accountpb.SelectionItem', null, global);
goog.exportSymbol('proto.accountpb.UpdateClientResponse', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.Client = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.Client, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.Client.displayName = 'proto.accountpb.Client';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.ReadClientRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.ReadClientRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.ReadClientRequest.displayName = 'proto.accountpb.ReadClientRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.ReadClientByUserRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.ReadClientByUserRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.ReadClientByUserRequest.displayName = 'proto.accountpb.ReadClientByUserRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.ReadClientResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountpb.ReadClientResponse.repeatedFields_, null);
};
goog.inherits(proto.accountpb.ReadClientResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.ReadClientResponse.displayName = 'proto.accountpb.ReadClientResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.UpdateClientResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.UpdateClientResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.UpdateClientResponse.displayName = 'proto.accountpb.UpdateClientResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.GetAccountIdResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.GetAccountIdResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.GetAccountIdResponse.displayName = 'proto.accountpb.GetAccountIdResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.ListClientRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.ListClientRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.ListClientRequest.displayName = 'proto.accountpb.ListClientRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.ListClientResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountpb.ListClientResponse.repeatedFields_, null);
};
goog.inherits(proto.accountpb.ListClientResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.ListClientResponse.displayName = 'proto.accountpb.ListClientResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.EmptyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.EmptyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.EmptyRequest.displayName = 'proto.accountpb.EmptyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.SelectionItem = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.SelectionItem, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.SelectionItem.displayName = 'proto.accountpb.SelectionItem';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.ListSelectionItemResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.accountpb.ListSelectionItemResponse.repeatedFields_, null);
};
goog.inherits(proto.accountpb.ListSelectionItemResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.ListSelectionItemResponse.displayName = 'proto.accountpb.ListSelectionItemResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.ListSubAccountTypeItemRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.ListSubAccountTypeItemRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.ListSubAccountTypeItemRequest.displayName = 'proto.accountpb.ListSubAccountTypeItemRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.GetAccountInfoRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.GetAccountInfoRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.GetAccountInfoRequest.displayName = 'proto.accountpb.GetAccountInfoRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.GetAccountInfoResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.GetAccountInfoResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.GetAccountInfoResponse.displayName = 'proto.accountpb.GetAccountInfoResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.accountpb.GetUserAccountIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.accountpb.GetUserAccountIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.accountpb.GetUserAccountIdRequest.displayName = 'proto.accountpb.GetUserAccountIdRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.Client.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.Client.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.Client} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.Client.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    correspondent: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    status: jspb.Message.getFieldWithDefault(msg, 6, ""),
    activatedAt: (f = msg.getActivatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    pendingClosureAt: (f = msg.getPendingClosureAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    broker: jspb.Message.getFieldWithDefault(msg, 9, ""),
    fpslParticipant: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    privacyConsent: jspb.Message.getFieldWithDefault(msg, 11, ""),
    dayTrader: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    multiplier: jspb.Message.getFieldWithDefault(msg, 13, ""),
    investmentObjectiveCode: jspb.Message.getFieldWithDefault(msg, 14, ""),
    investmentObjectiveDate: (f = msg.getInvestmentObjectiveDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    legalEntity: jspb.Message.getFieldWithDefault(msg, 16, ""),
    taxCountry: jspb.Message.getFieldWithDefault(msg, 17, ""),
    w8w9: jspb.Message.getFieldWithDefault(msg, 18, ""),
    w8w9ReceivedDate: (f = msg.getW8w9ReceivedDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    tefra: jspb.Message.getFieldWithDefault(msg, 20, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdBy: jspb.Message.getFieldWithDefault(msg, 22, ""),
    accreditedInvestor: jspb.Message.getBooleanFieldWithDefault(msg, 23, false),
    fdidFlag: jspb.Message.getBooleanFieldWithDefault(msg, 24, false),
    fdid: jspb.Message.getFieldWithDefault(msg, 25, ""),
    fdidEndReason: jspb.Message.getFieldWithDefault(msg, 26, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 27, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 28, ""),
    accountType: jspb.Message.getFieldWithDefault(msg, 29, ""),
    marginType: jspb.Message.getFieldWithDefault(msg, 30, ""),
    largeTraderId: jspb.Message.getFieldWithDefault(msg, 31, ""),
    subAccounts: jspb.Message.getFieldWithDefault(msg, 32, ""),
    batchNo: jspb.Message.getFieldWithDefault(msg, 33, ""),
    errorMessage: jspb.Message.getFieldWithDefault(msg, 34, ""),
    validationStatus: jspb.Message.getFieldWithDefault(msg, 35, ""),
    commonId: jspb.Message.getFieldWithDefault(msg, 36, ""),
    modifiedAt: (f = msg.getModifiedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    modifiedBy: jspb.Message.getFieldWithDefault(msg, 38, ""),
    subType: jspb.Message.getFieldWithDefault(msg, 39, ""),
    statusReason: jspb.Message.getFieldWithDefault(msg, 40, ""),
    allowLiquidInvestment: jspb.Message.getBooleanFieldWithDefault(msg, 41, false),
    webTermConditions: (f = msg.getWebTermConditions()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    disclosureStatement: (f = msg.getDisclosureStatement()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    feeSchedule: (f = msg.getFeeSchedule()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    beneficiary: jspb.Message.getFieldWithDefault(msg, 45, ""),
    participantNo: jspb.Message.getFieldWithDefault(msg, 47, ""),
    traderId: jspb.Message.getFieldWithDefault(msg, 52, ""),
    marginDisclosure: jspb.Message.getBooleanFieldWithDefault(msg, 53, false),
    stocks: jspb.Message.getBooleanFieldWithDefault(msg, 54, false),
    etf: jspb.Message.getBooleanFieldWithDefault(msg, 55, false),
    option: jspb.Message.getBooleanFieldWithDefault(msg, 56, false),
    annualIncome: jspb.Message.getFieldWithDefault(msg, 57, ""),
    liquidNetWorth: jspb.Message.getFieldWithDefault(msg, 58, ""),
    sourceOfFunds: jspb.Message.getFieldWithDefault(msg, 59, ""),
    signed: jspb.Message.getBooleanFieldWithDefault(msg, 60, false),
    imgSignature: jspb.Message.getFieldWithDefault(msg, 61, ""),
    marginAgreement: jspb.Message.getBooleanFieldWithDefault(msg, 62, false),
    usrId: jspb.Message.getFieldWithDefault(msg, 63, 0),
    kycStatus: jspb.Message.getFieldWithDefault(msg, 64, ""),
    type: jspb.Message.getFieldWithDefault(msg, 65, ""),
    msg: jspb.Message.getFieldWithDefault(msg, 66, ""),
    currency: jspb.Message.getFieldWithDefault(msg, 67, ""),
    promoCode: jspb.Message.getFieldWithDefault(msg, 68, ""),
    securityWord: jspb.Message.getFieldWithDefault(msg, 69, ""),
    securityWordHint: jspb.Message.getFieldWithDefault(msg, 70, ""),
    taxBracket: jspb.Message.getFieldWithDefault(msg, 71, 0),
    riskTolerance: jspb.Message.getFieldWithDefault(msg, 72, ""),
    customerAccountAgreement: jspb.Message.getBooleanFieldWithDefault(msg, 73, false),
    onboardingPercent: jspb.Message.getFieldWithDefault(msg, 74, ""),
    tin: jspb.Message.getFieldWithDefault(msg, 75, ""),
    formationCountry: jspb.Message.getFieldWithDefault(msg, 76, ""),
    emailAddress: jspb.Message.getFieldWithDefault(msg, 77, ""),
    lastActivityDate: (f = msg.getLastActivityDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    ctmTradesuite: jspb.Message.getFieldWithDefault(msg, 79, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.Client}
 */
proto.accountpb.Client.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.Client;
  return proto.accountpb.Client.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.Client} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.Client}
 */
proto.accountpb.Client.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setActivatedAt(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPendingClosureAt(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFpslParticipant(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrivacyConsent(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDayTrader(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setMultiplier(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setInvestmentObjectiveCode(value);
      break;
    case 15:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setInvestmentObjectiveDate(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setLegalEntity(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaxCountry(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setW8w9(value);
      break;
    case 19:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setW8w9ReceivedDate(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setTefra(value);
      break;
    case 21:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 22:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    case 23:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccreditedInvestor(value);
      break;
    case 24:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFdidFlag(value);
      break;
    case 25:
      var value = /** @type {string} */ (reader.readString());
      msg.setFdid(value);
      break;
    case 26:
      var value = /** @type {string} */ (reader.readString());
      msg.setFdidEndReason(value);
      break;
    case 27:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 28:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 29:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountType(value);
      break;
    case 30:
      var value = /** @type {string} */ (reader.readString());
      msg.setMarginType(value);
      break;
    case 31:
      var value = /** @type {string} */ (reader.readString());
      msg.setLargeTraderId(value);
      break;
    case 32:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccounts(value);
      break;
    case 33:
      var value = /** @type {string} */ (reader.readString());
      msg.setBatchNo(value);
      break;
    case 34:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMessage(value);
      break;
    case 35:
      var value = /** @type {string} */ (reader.readString());
      msg.setValidationStatus(value);
      break;
    case 36:
      var value = /** @type {string} */ (reader.readString());
      msg.setCommonId(value);
      break;
    case 37:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setModifiedAt(value);
      break;
    case 38:
      var value = /** @type {string} */ (reader.readString());
      msg.setModifiedBy(value);
      break;
    case 39:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubType(value);
      break;
    case 40:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatusReason(value);
      break;
    case 41:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowLiquidInvestment(value);
      break;
    case 42:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWebTermConditions(value);
      break;
    case 43:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setDisclosureStatement(value);
      break;
    case 44:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setFeeSchedule(value);
      break;
    case 45:
      var value = /** @type {string} */ (reader.readString());
      msg.setBeneficiary(value);
      break;
    case 47:
      var value = /** @type {string} */ (reader.readString());
      msg.setParticipantNo(value);
      break;
    case 52:
      var value = /** @type {string} */ (reader.readString());
      msg.setTraderId(value);
      break;
    case 53:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarginDisclosure(value);
      break;
    case 54:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStocks(value);
      break;
    case 55:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEtf(value);
      break;
    case 56:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setOption(value);
      break;
    case 57:
      var value = /** @type {string} */ (reader.readString());
      msg.setAnnualIncome(value);
      break;
    case 58:
      var value = /** @type {string} */ (reader.readString());
      msg.setLiquidNetWorth(value);
      break;
    case 59:
      var value = /** @type {string} */ (reader.readString());
      msg.setSourceOfFunds(value);
      break;
    case 60:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSigned(value);
      break;
    case 61:
      var value = /** @type {string} */ (reader.readString());
      msg.setImgSignature(value);
      break;
    case 62:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMarginAgreement(value);
      break;
    case 63:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUsrId(value);
      break;
    case 64:
      var value = /** @type {string} */ (reader.readString());
      msg.setKycStatus(value);
      break;
    case 65:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 66:
      var value = /** @type {string} */ (reader.readString());
      msg.setMsg(value);
      break;
    case 67:
      var value = /** @type {string} */ (reader.readString());
      msg.setCurrency(value);
      break;
    case 68:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromoCode(value);
      break;
    case 69:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityWord(value);
      break;
    case 70:
      var value = /** @type {string} */ (reader.readString());
      msg.setSecurityWordHint(value);
      break;
    case 71:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTaxBracket(value);
      break;
    case 72:
      var value = /** @type {string} */ (reader.readString());
      msg.setRiskTolerance(value);
      break;
    case 73:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCustomerAccountAgreement(value);
      break;
    case 74:
      var value = /** @type {string} */ (reader.readString());
      msg.setOnboardingPercent(value);
      break;
    case 75:
      var value = /** @type {string} */ (reader.readString());
      msg.setTin(value);
      break;
    case 76:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormationCountry(value);
      break;
    case 77:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmailAddress(value);
      break;
    case 78:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setLastActivityDate(value);
      break;
    case 79:
      var value = /** @type {string} */ (reader.readString());
      msg.setCtmTradesuite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.Client.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.Client.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.Client} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.Client.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getActivatedAt();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPendingClosureAt();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getFpslParticipant();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getPrivacyConsent();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getDayTrader();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getMultiplier();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getInvestmentObjectiveCode();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getInvestmentObjectiveDate();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getLegalEntity();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getTaxCountry();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getW8w9();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getW8w9ReceivedDate();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getTefra();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      22,
      f
    );
  }
  f = message.getAccreditedInvestor();
  if (f) {
    writer.writeBool(
      23,
      f
    );
  }
  f = message.getFdidFlag();
  if (f) {
    writer.writeBool(
      24,
      f
    );
  }
  f = message.getFdid();
  if (f.length > 0) {
    writer.writeString(
      25,
      f
    );
  }
  f = message.getFdidEndReason();
  if (f.length > 0) {
    writer.writeString(
      26,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      27,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      28,
      f
    );
  }
  f = message.getAccountType();
  if (f.length > 0) {
    writer.writeString(
      29,
      f
    );
  }
  f = message.getMarginType();
  if (f.length > 0) {
    writer.writeString(
      30,
      f
    );
  }
  f = message.getLargeTraderId();
  if (f.length > 0) {
    writer.writeString(
      31,
      f
    );
  }
  f = message.getSubAccounts();
  if (f.length > 0) {
    writer.writeString(
      32,
      f
    );
  }
  f = message.getBatchNo();
  if (f.length > 0) {
    writer.writeString(
      33,
      f
    );
  }
  f = message.getErrorMessage();
  if (f.length > 0) {
    writer.writeString(
      34,
      f
    );
  }
  f = message.getValidationStatus();
  if (f.length > 0) {
    writer.writeString(
      35,
      f
    );
  }
  f = message.getCommonId();
  if (f.length > 0) {
    writer.writeString(
      36,
      f
    );
  }
  f = message.getModifiedAt();
  if (f != null) {
    writer.writeMessage(
      37,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getModifiedBy();
  if (f.length > 0) {
    writer.writeString(
      38,
      f
    );
  }
  f = message.getSubType();
  if (f.length > 0) {
    writer.writeString(
      39,
      f
    );
  }
  f = message.getStatusReason();
  if (f.length > 0) {
    writer.writeString(
      40,
      f
    );
  }
  f = message.getAllowLiquidInvestment();
  if (f) {
    writer.writeBool(
      41,
      f
    );
  }
  f = message.getWebTermConditions();
  if (f != null) {
    writer.writeMessage(
      42,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getDisclosureStatement();
  if (f != null) {
    writer.writeMessage(
      43,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getFeeSchedule();
  if (f != null) {
    writer.writeMessage(
      44,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getBeneficiary();
  if (f.length > 0) {
    writer.writeString(
      45,
      f
    );
  }
  f = message.getParticipantNo();
  if (f.length > 0) {
    writer.writeString(
      47,
      f
    );
  }
  f = message.getTraderId();
  if (f.length > 0) {
    writer.writeString(
      52,
      f
    );
  }
  f = message.getMarginDisclosure();
  if (f) {
    writer.writeBool(
      53,
      f
    );
  }
  f = message.getStocks();
  if (f) {
    writer.writeBool(
      54,
      f
    );
  }
  f = message.getEtf();
  if (f) {
    writer.writeBool(
      55,
      f
    );
  }
  f = message.getOption();
  if (f) {
    writer.writeBool(
      56,
      f
    );
  }
  f = message.getAnnualIncome();
  if (f.length > 0) {
    writer.writeString(
      57,
      f
    );
  }
  f = message.getLiquidNetWorth();
  if (f.length > 0) {
    writer.writeString(
      58,
      f
    );
  }
  f = message.getSourceOfFunds();
  if (f.length > 0) {
    writer.writeString(
      59,
      f
    );
  }
  f = message.getSigned();
  if (f) {
    writer.writeBool(
      60,
      f
    );
  }
  f = message.getImgSignature();
  if (f.length > 0) {
    writer.writeString(
      61,
      f
    );
  }
  f = message.getMarginAgreement();
  if (f) {
    writer.writeBool(
      62,
      f
    );
  }
  f = message.getUsrId();
  if (f !== 0) {
    writer.writeUint32(
      63,
      f
    );
  }
  f = message.getKycStatus();
  if (f.length > 0) {
    writer.writeString(
      64,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      65,
      f
    );
  }
  f = message.getMsg();
  if (f.length > 0) {
    writer.writeString(
      66,
      f
    );
  }
  f = message.getCurrency();
  if (f.length > 0) {
    writer.writeString(
      67,
      f
    );
  }
  f = message.getPromoCode();
  if (f.length > 0) {
    writer.writeString(
      68,
      f
    );
  }
  f = message.getSecurityWord();
  if (f.length > 0) {
    writer.writeString(
      69,
      f
    );
  }
  f = message.getSecurityWordHint();
  if (f.length > 0) {
    writer.writeString(
      70,
      f
    );
  }
  f = message.getTaxBracket();
  if (f !== 0) {
    writer.writeInt32(
      71,
      f
    );
  }
  f = message.getRiskTolerance();
  if (f.length > 0) {
    writer.writeString(
      72,
      f
    );
  }
  f = message.getCustomerAccountAgreement();
  if (f) {
    writer.writeBool(
      73,
      f
    );
  }
  f = message.getOnboardingPercent();
  if (f.length > 0) {
    writer.writeString(
      74,
      f
    );
  }
  f = message.getTin();
  if (f.length > 0) {
    writer.writeString(
      75,
      f
    );
  }
  f = message.getFormationCountry();
  if (f.length > 0) {
    writer.writeString(
      76,
      f
    );
  }
  f = message.getEmailAddress();
  if (f.length > 0) {
    writer.writeString(
      77,
      f
    );
  }
  f = message.getLastActivityDate();
  if (f != null) {
    writer.writeMessage(
      78,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getCtmTradesuite();
  if (f.length > 0) {
    writer.writeString(
      79,
      f
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.accountpb.Client.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string correspondent = 2;
 * @return {string}
 */
proto.accountpb.Client.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_no = 3;
 * @return {string}
 */
proto.accountpb.Client.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_name = 4;
 * @return {string}
 */
proto.accountpb.Client.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string master_account_no = 5;
 * @return {string}
 */
proto.accountpb.Client.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string status = 6;
 * @return {string}
 */
proto.accountpb.Client.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp activated_at = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountpb.Client.prototype.getActivatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountpb.Client} returns this
*/
proto.accountpb.Client.prototype.setActivatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.clearActivatedAt = function() {
  return this.setActivatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Client.prototype.hasActivatedAt = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp pending_closure_at = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountpb.Client.prototype.getPendingClosureAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountpb.Client} returns this
*/
proto.accountpb.Client.prototype.setPendingClosureAt = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.clearPendingClosureAt = function() {
  return this.setPendingClosureAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Client.prototype.hasPendingClosureAt = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional string broker = 9;
 * @return {string}
 */
proto.accountpb.Client.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional bool fpsl_participant = 10;
 * @return {boolean}
 */
proto.accountpb.Client.prototype.getFpslParticipant = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setFpslParticipant = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string privacy_consent = 11;
 * @return {string}
 */
proto.accountpb.Client.prototype.getPrivacyConsent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setPrivacyConsent = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool day_trader = 12;
 * @return {boolean}
 */
proto.accountpb.Client.prototype.getDayTrader = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setDayTrader = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional string multiplier = 13;
 * @return {string}
 */
proto.accountpb.Client.prototype.getMultiplier = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setMultiplier = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string investment_objective_code = 14;
 * @return {string}
 */
proto.accountpb.Client.prototype.getInvestmentObjectiveCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setInvestmentObjectiveCode = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional google.type.Date investment_objective_date = 15;
 * @return {?proto.google.type.Date}
 */
proto.accountpb.Client.prototype.getInvestmentObjectiveDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 15));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.accountpb.Client} returns this
*/
proto.accountpb.Client.prototype.setInvestmentObjectiveDate = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.clearInvestmentObjectiveDate = function() {
  return this.setInvestmentObjectiveDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Client.prototype.hasInvestmentObjectiveDate = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional string legal_entity = 16;
 * @return {string}
 */
proto.accountpb.Client.prototype.getLegalEntity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setLegalEntity = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string tax_country = 17;
 * @return {string}
 */
proto.accountpb.Client.prototype.getTaxCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setTaxCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string w8w9 = 18;
 * @return {string}
 */
proto.accountpb.Client.prototype.getW8w9 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setW8w9 = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional google.type.Date w8w9_received_date = 19;
 * @return {?proto.google.type.Date}
 */
proto.accountpb.Client.prototype.getW8w9ReceivedDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 19));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.accountpb.Client} returns this
*/
proto.accountpb.Client.prototype.setW8w9ReceivedDate = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.clearW8w9ReceivedDate = function() {
  return this.setW8w9ReceivedDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Client.prototype.hasW8w9ReceivedDate = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional string tefra = 20;
 * @return {string}
 */
proto.accountpb.Client.prototype.getTefra = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setTefra = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 21;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountpb.Client.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 21));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountpb.Client} returns this
*/
proto.accountpb.Client.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Client.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional string created_by = 22;
 * @return {string}
 */
proto.accountpb.Client.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 22, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 22, value);
};


/**
 * optional bool accredited_investor = 23;
 * @return {boolean}
 */
proto.accountpb.Client.prototype.getAccreditedInvestor = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 23, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setAccreditedInvestor = function(value) {
  return jspb.Message.setProto3BooleanField(this, 23, value);
};


/**
 * optional bool fdid_flag = 24;
 * @return {boolean}
 */
proto.accountpb.Client.prototype.getFdidFlag = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 24, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setFdidFlag = function(value) {
  return jspb.Message.setProto3BooleanField(this, 24, value);
};


/**
 * optional string fdid = 25;
 * @return {string}
 */
proto.accountpb.Client.prototype.getFdid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 25, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setFdid = function(value) {
  return jspb.Message.setProto3StringField(this, 25, value);
};


/**
 * optional string fdid_end_reason = 26;
 * @return {string}
 */
proto.accountpb.Client.prototype.getFdidEndReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 26, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setFdidEndReason = function(value) {
  return jspb.Message.setProto3StringField(this, 26, value);
};


/**
 * optional string branch = 27;
 * @return {string}
 */
proto.accountpb.Client.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 27, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 27, value);
};


/**
 * optional string rep = 28;
 * @return {string}
 */
proto.accountpb.Client.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 28, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 28, value);
};


/**
 * optional string account_type = 29;
 * @return {string}
 */
proto.accountpb.Client.prototype.getAccountType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 29, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3StringField(this, 29, value);
};


/**
 * optional string margin_type = 30;
 * @return {string}
 */
proto.accountpb.Client.prototype.getMarginType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 30, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setMarginType = function(value) {
  return jspb.Message.setProto3StringField(this, 30, value);
};


/**
 * optional string large_trader_id = 31;
 * @return {string}
 */
proto.accountpb.Client.prototype.getLargeTraderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 31, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setLargeTraderId = function(value) {
  return jspb.Message.setProto3StringField(this, 31, value);
};


/**
 * optional string sub_accounts = 32;
 * @return {string}
 */
proto.accountpb.Client.prototype.getSubAccounts = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 32, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setSubAccounts = function(value) {
  return jspb.Message.setProto3StringField(this, 32, value);
};


/**
 * optional string batch_no = 33;
 * @return {string}
 */
proto.accountpb.Client.prototype.getBatchNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 33, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setBatchNo = function(value) {
  return jspb.Message.setProto3StringField(this, 33, value);
};


/**
 * optional string error_message = 34;
 * @return {string}
 */
proto.accountpb.Client.prototype.getErrorMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 34, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setErrorMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 34, value);
};


/**
 * optional string validation_status = 35;
 * @return {string}
 */
proto.accountpb.Client.prototype.getValidationStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 35, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setValidationStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 35, value);
};


/**
 * optional string common_id = 36;
 * @return {string}
 */
proto.accountpb.Client.prototype.getCommonId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 36, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setCommonId = function(value) {
  return jspb.Message.setProto3StringField(this, 36, value);
};


/**
 * optional google.protobuf.Timestamp modified_at = 37;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountpb.Client.prototype.getModifiedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 37));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountpb.Client} returns this
*/
proto.accountpb.Client.prototype.setModifiedAt = function(value) {
  return jspb.Message.setWrapperField(this, 37, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.clearModifiedAt = function() {
  return this.setModifiedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Client.prototype.hasModifiedAt = function() {
  return jspb.Message.getField(this, 37) != null;
};


/**
 * optional string modified_by = 38;
 * @return {string}
 */
proto.accountpb.Client.prototype.getModifiedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 38, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setModifiedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 38, value);
};


/**
 * optional string sub_type = 39;
 * @return {string}
 */
proto.accountpb.Client.prototype.getSubType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 39, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setSubType = function(value) {
  return jspb.Message.setProto3StringField(this, 39, value);
};


/**
 * optional string status_reason = 40;
 * @return {string}
 */
proto.accountpb.Client.prototype.getStatusReason = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 40, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setStatusReason = function(value) {
  return jspb.Message.setProto3StringField(this, 40, value);
};


/**
 * optional bool allow_liquid_investment = 41;
 * @return {boolean}
 */
proto.accountpb.Client.prototype.getAllowLiquidInvestment = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 41, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setAllowLiquidInvestment = function(value) {
  return jspb.Message.setProto3BooleanField(this, 41, value);
};


/**
 * optional google.protobuf.Timestamp web_term_conditions = 42;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountpb.Client.prototype.getWebTermConditions = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 42));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountpb.Client} returns this
*/
proto.accountpb.Client.prototype.setWebTermConditions = function(value) {
  return jspb.Message.setWrapperField(this, 42, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.clearWebTermConditions = function() {
  return this.setWebTermConditions(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Client.prototype.hasWebTermConditions = function() {
  return jspb.Message.getField(this, 42) != null;
};


/**
 * optional google.protobuf.Timestamp disclosure_statement = 43;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountpb.Client.prototype.getDisclosureStatement = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 43));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountpb.Client} returns this
*/
proto.accountpb.Client.prototype.setDisclosureStatement = function(value) {
  return jspb.Message.setWrapperField(this, 43, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.clearDisclosureStatement = function() {
  return this.setDisclosureStatement(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Client.prototype.hasDisclosureStatement = function() {
  return jspb.Message.getField(this, 43) != null;
};


/**
 * optional google.protobuf.Timestamp fee_schedule = 44;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.accountpb.Client.prototype.getFeeSchedule = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 44));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.accountpb.Client} returns this
*/
proto.accountpb.Client.prototype.setFeeSchedule = function(value) {
  return jspb.Message.setWrapperField(this, 44, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.clearFeeSchedule = function() {
  return this.setFeeSchedule(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Client.prototype.hasFeeSchedule = function() {
  return jspb.Message.getField(this, 44) != null;
};


/**
 * optional string beneficiary = 45;
 * @return {string}
 */
proto.accountpb.Client.prototype.getBeneficiary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 45, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setBeneficiary = function(value) {
  return jspb.Message.setProto3StringField(this, 45, value);
};


/**
 * optional string participant_no = 47;
 * @return {string}
 */
proto.accountpb.Client.prototype.getParticipantNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 47, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setParticipantNo = function(value) {
  return jspb.Message.setProto3StringField(this, 47, value);
};


/**
 * optional string trader_id = 52;
 * @return {string}
 */
proto.accountpb.Client.prototype.getTraderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 52, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setTraderId = function(value) {
  return jspb.Message.setProto3StringField(this, 52, value);
};


/**
 * optional bool margin_disclosure = 53;
 * @return {boolean}
 */
proto.accountpb.Client.prototype.getMarginDisclosure = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 53, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setMarginDisclosure = function(value) {
  return jspb.Message.setProto3BooleanField(this, 53, value);
};


/**
 * optional bool stocks = 54;
 * @return {boolean}
 */
proto.accountpb.Client.prototype.getStocks = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 54, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setStocks = function(value) {
  return jspb.Message.setProto3BooleanField(this, 54, value);
};


/**
 * optional bool etf = 55;
 * @return {boolean}
 */
proto.accountpb.Client.prototype.getEtf = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 55, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setEtf = function(value) {
  return jspb.Message.setProto3BooleanField(this, 55, value);
};


/**
 * optional bool option = 56;
 * @return {boolean}
 */
proto.accountpb.Client.prototype.getOption = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 56, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setOption = function(value) {
  return jspb.Message.setProto3BooleanField(this, 56, value);
};


/**
 * optional string annual_income = 57;
 * @return {string}
 */
proto.accountpb.Client.prototype.getAnnualIncome = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 57, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setAnnualIncome = function(value) {
  return jspb.Message.setProto3StringField(this, 57, value);
};


/**
 * optional string liquid_net_worth = 58;
 * @return {string}
 */
proto.accountpb.Client.prototype.getLiquidNetWorth = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 58, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setLiquidNetWorth = function(value) {
  return jspb.Message.setProto3StringField(this, 58, value);
};


/**
 * optional string source_of_funds = 59;
 * @return {string}
 */
proto.accountpb.Client.prototype.getSourceOfFunds = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 59, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setSourceOfFunds = function(value) {
  return jspb.Message.setProto3StringField(this, 59, value);
};


/**
 * optional bool signed = 60;
 * @return {boolean}
 */
proto.accountpb.Client.prototype.getSigned = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 60, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setSigned = function(value) {
  return jspb.Message.setProto3BooleanField(this, 60, value);
};


/**
 * optional string img_signature = 61;
 * @return {string}
 */
proto.accountpb.Client.prototype.getImgSignature = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 61, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setImgSignature = function(value) {
  return jspb.Message.setProto3StringField(this, 61, value);
};


/**
 * optional bool margin_agreement = 62;
 * @return {boolean}
 */
proto.accountpb.Client.prototype.getMarginAgreement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 62, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setMarginAgreement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 62, value);
};


/**
 * optional uint32 usr_id = 63;
 * @return {number}
 */
proto.accountpb.Client.prototype.getUsrId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 63, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setUsrId = function(value) {
  return jspb.Message.setProto3IntField(this, 63, value);
};


/**
 * optional string kyc_status = 64;
 * @return {string}
 */
proto.accountpb.Client.prototype.getKycStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 64, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setKycStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 64, value);
};


/**
 * optional string type = 65;
 * @return {string}
 */
proto.accountpb.Client.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 65, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 65, value);
};


/**
 * optional string msg = 66;
 * @return {string}
 */
proto.accountpb.Client.prototype.getMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 66, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 66, value);
};


/**
 * optional string currency = 67;
 * @return {string}
 */
proto.accountpb.Client.prototype.getCurrency = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 67, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setCurrency = function(value) {
  return jspb.Message.setProto3StringField(this, 67, value);
};


/**
 * optional string promo_code = 68;
 * @return {string}
 */
proto.accountpb.Client.prototype.getPromoCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 68, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setPromoCode = function(value) {
  return jspb.Message.setProto3StringField(this, 68, value);
};


/**
 * optional string security_word = 69;
 * @return {string}
 */
proto.accountpb.Client.prototype.getSecurityWord = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 69, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setSecurityWord = function(value) {
  return jspb.Message.setProto3StringField(this, 69, value);
};


/**
 * optional string security_word_hint = 70;
 * @return {string}
 */
proto.accountpb.Client.prototype.getSecurityWordHint = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 70, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setSecurityWordHint = function(value) {
  return jspb.Message.setProto3StringField(this, 70, value);
};


/**
 * optional int32 tax_bracket = 71;
 * @return {number}
 */
proto.accountpb.Client.prototype.getTaxBracket = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 71, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setTaxBracket = function(value) {
  return jspb.Message.setProto3IntField(this, 71, value);
};


/**
 * optional string risk_tolerance = 72;
 * @return {string}
 */
proto.accountpb.Client.prototype.getRiskTolerance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 72, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setRiskTolerance = function(value) {
  return jspb.Message.setProto3StringField(this, 72, value);
};


/**
 * optional bool customer_account_agreement = 73;
 * @return {boolean}
 */
proto.accountpb.Client.prototype.getCustomerAccountAgreement = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 73, false));
};


/**
 * @param {boolean} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setCustomerAccountAgreement = function(value) {
  return jspb.Message.setProto3BooleanField(this, 73, value);
};


/**
 * optional string onboarding_percent = 74;
 * @return {string}
 */
proto.accountpb.Client.prototype.getOnboardingPercent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 74, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setOnboardingPercent = function(value) {
  return jspb.Message.setProto3StringField(this, 74, value);
};


/**
 * optional string tin = 75;
 * @return {string}
 */
proto.accountpb.Client.prototype.getTin = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 75, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setTin = function(value) {
  return jspb.Message.setProto3StringField(this, 75, value);
};


/**
 * optional string formation_country = 76;
 * @return {string}
 */
proto.accountpb.Client.prototype.getFormationCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 76, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setFormationCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 76, value);
};


/**
 * optional string email_address = 77;
 * @return {string}
 */
proto.accountpb.Client.prototype.getEmailAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 77, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setEmailAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 77, value);
};


/**
 * optional google.type.Date last_activity_date = 78;
 * @return {?proto.google.type.Date}
 */
proto.accountpb.Client.prototype.getLastActivityDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 78));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.accountpb.Client} returns this
*/
proto.accountpb.Client.prototype.setLastActivityDate = function(value) {
  return jspb.Message.setWrapperField(this, 78, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.clearLastActivityDate = function() {
  return this.setLastActivityDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.Client.prototype.hasLastActivityDate = function() {
  return jspb.Message.getField(this, 78) != null;
};


/**
 * optional string ctm_tradesuite = 79;
 * @return {string}
 */
proto.accountpb.Client.prototype.getCtmTradesuite = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 79, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.Client} returns this
 */
proto.accountpb.Client.prototype.setCtmTradesuite = function(value) {
  return jspb.Message.setProto3StringField(this, 79, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.ReadClientRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.ReadClientRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.ReadClientRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ReadClientRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.ReadClientRequest}
 */
proto.accountpb.ReadClientRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.ReadClientRequest;
  return proto.accountpb.ReadClientRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.ReadClientRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.ReadClientRequest}
 */
proto.accountpb.ReadClientRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.ReadClientRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.ReadClientRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.ReadClientRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ReadClientRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.accountpb.ReadClientRequest.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.ReadClientRequest} returns this
 */
proto.accountpb.ReadClientRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.ReadClientByUserRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.ReadClientByUserRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.ReadClientByUserRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ReadClientByUserRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    usrId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.ReadClientByUserRequest}
 */
proto.accountpb.ReadClientByUserRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.ReadClientByUserRequest;
  return proto.accountpb.ReadClientByUserRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.ReadClientByUserRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.ReadClientByUserRequest}
 */
proto.accountpb.ReadClientByUserRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUsrId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.ReadClientByUserRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.ReadClientByUserRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.ReadClientByUserRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ReadClientByUserRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsrId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 usr_id = 1;
 * @return {number}
 */
proto.accountpb.ReadClientByUserRequest.prototype.getUsrId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.ReadClientByUserRequest} returns this
 */
proto.accountpb.ReadClientByUserRequest.prototype.setUsrId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountpb.ReadClientResponse.repeatedFields_ = [2,3,4,5,6,7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.ReadClientResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.ReadClientResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.ReadClientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ReadClientResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.accountpb.Client.toObject(includeInstance, f),
    ownersList: jspb.Message.toObjectList(msg.getOwnersList(),
    proto_accountpb_owner_pb.Owner.toObject, includeInstance),
    addressesList: jspb.Message.toObjectList(msg.getAddressesList(),
    proto_accountpb_address_pb.Address.toObject, includeInstance),
    contactInfosList: jspb.Message.toObjectList(msg.getContactInfosList(),
    proto_accountpb_contactinfo_pb.ContactInfo.toObject, includeInstance),
    identificationsList: jspb.Message.toObjectList(msg.getIdentificationsList(),
    proto_accountpb_identification_pb.Identification.toObject, includeInstance),
    notesList: jspb.Message.toObjectList(msg.getNotesList(),
    proto_accountpb_note_pb.Note.toObject, includeInstance),
    subAccountsList: jspb.Message.toObjectList(msg.getSubAccountsList(),
    proto_accountpb_subaccount_pb.SubAccount.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.ReadClientResponse}
 */
proto.accountpb.ReadClientResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.ReadClientResponse;
  return proto.accountpb.ReadClientResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.ReadClientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.ReadClientResponse}
 */
proto.accountpb.ReadClientResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountpb.Client;
      reader.readMessage(value,proto.accountpb.Client.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    case 2:
      var value = new proto_accountpb_owner_pb.Owner;
      reader.readMessage(value,proto_accountpb_owner_pb.Owner.deserializeBinaryFromReader);
      msg.addOwners(value);
      break;
    case 3:
      var value = new proto_accountpb_address_pb.Address;
      reader.readMessage(value,proto_accountpb_address_pb.Address.deserializeBinaryFromReader);
      msg.addAddresses(value);
      break;
    case 4:
      var value = new proto_accountpb_contactinfo_pb.ContactInfo;
      reader.readMessage(value,proto_accountpb_contactinfo_pb.ContactInfo.deserializeBinaryFromReader);
      msg.addContactInfos(value);
      break;
    case 5:
      var value = new proto_accountpb_identification_pb.Identification;
      reader.readMessage(value,proto_accountpb_identification_pb.Identification.deserializeBinaryFromReader);
      msg.addIdentifications(value);
      break;
    case 6:
      var value = new proto_accountpb_note_pb.Note;
      reader.readMessage(value,proto_accountpb_note_pb.Note.deserializeBinaryFromReader);
      msg.addNotes(value);
      break;
    case 7:
      var value = new proto_accountpb_subaccount_pb.SubAccount;
      reader.readMessage(value,proto_accountpb_subaccount_pb.SubAccount.deserializeBinaryFromReader);
      msg.addSubAccounts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.ReadClientResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.ReadClientResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.ReadClientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ReadClientResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.accountpb.Client.serializeBinaryToWriter
    );
  }
  f = message.getOwnersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto_accountpb_owner_pb.Owner.serializeBinaryToWriter
    );
  }
  f = message.getAddressesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto_accountpb_address_pb.Address.serializeBinaryToWriter
    );
  }
  f = message.getContactInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto_accountpb_contactinfo_pb.ContactInfo.serializeBinaryToWriter
    );
  }
  f = message.getIdentificationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto_accountpb_identification_pb.Identification.serializeBinaryToWriter
    );
  }
  f = message.getNotesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto_accountpb_note_pb.Note.serializeBinaryToWriter
    );
  }
  f = message.getSubAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto_accountpb_subaccount_pb.SubAccount.serializeBinaryToWriter
    );
  }
};


/**
 * optional Client client = 1;
 * @return {?proto.accountpb.Client}
 */
proto.accountpb.ReadClientResponse.prototype.getClient = function() {
  return /** @type{?proto.accountpb.Client} */ (
    jspb.Message.getWrapperField(this, proto.accountpb.Client, 1));
};


/**
 * @param {?proto.accountpb.Client|undefined} value
 * @return {!proto.accountpb.ReadClientResponse} returns this
*/
proto.accountpb.ReadClientResponse.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.ReadClientResponse} returns this
 */
proto.accountpb.ReadClientResponse.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.ReadClientResponse.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Owner owners = 2;
 * @return {!Array<!proto.accountpb.Owner>}
 */
proto.accountpb.ReadClientResponse.prototype.getOwnersList = function() {
  return /** @type{!Array<!proto.accountpb.Owner>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_accountpb_owner_pb.Owner, 2));
};


/**
 * @param {!Array<!proto.accountpb.Owner>} value
 * @return {!proto.accountpb.ReadClientResponse} returns this
*/
proto.accountpb.ReadClientResponse.prototype.setOwnersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.accountpb.Owner=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.Owner}
 */
proto.accountpb.ReadClientResponse.prototype.addOwners = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.accountpb.Owner, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.ReadClientResponse} returns this
 */
proto.accountpb.ReadClientResponse.prototype.clearOwnersList = function() {
  return this.setOwnersList([]);
};


/**
 * repeated Address addresses = 3;
 * @return {!Array<!proto.accountpb.Address>}
 */
proto.accountpb.ReadClientResponse.prototype.getAddressesList = function() {
  return /** @type{!Array<!proto.accountpb.Address>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_accountpb_address_pb.Address, 3));
};


/**
 * @param {!Array<!proto.accountpb.Address>} value
 * @return {!proto.accountpb.ReadClientResponse} returns this
*/
proto.accountpb.ReadClientResponse.prototype.setAddressesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.accountpb.Address=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.Address}
 */
proto.accountpb.ReadClientResponse.prototype.addAddresses = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.accountpb.Address, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.ReadClientResponse} returns this
 */
proto.accountpb.ReadClientResponse.prototype.clearAddressesList = function() {
  return this.setAddressesList([]);
};


/**
 * repeated ContactInfo contact_infos = 4;
 * @return {!Array<!proto.accountpb.ContactInfo>}
 */
proto.accountpb.ReadClientResponse.prototype.getContactInfosList = function() {
  return /** @type{!Array<!proto.accountpb.ContactInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_accountpb_contactinfo_pb.ContactInfo, 4));
};


/**
 * @param {!Array<!proto.accountpb.ContactInfo>} value
 * @return {!proto.accountpb.ReadClientResponse} returns this
*/
proto.accountpb.ReadClientResponse.prototype.setContactInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.accountpb.ContactInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.ContactInfo}
 */
proto.accountpb.ReadClientResponse.prototype.addContactInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.accountpb.ContactInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.ReadClientResponse} returns this
 */
proto.accountpb.ReadClientResponse.prototype.clearContactInfosList = function() {
  return this.setContactInfosList([]);
};


/**
 * repeated Identification identifications = 5;
 * @return {!Array<!proto.accountpb.Identification>}
 */
proto.accountpb.ReadClientResponse.prototype.getIdentificationsList = function() {
  return /** @type{!Array<!proto.accountpb.Identification>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_accountpb_identification_pb.Identification, 5));
};


/**
 * @param {!Array<!proto.accountpb.Identification>} value
 * @return {!proto.accountpb.ReadClientResponse} returns this
*/
proto.accountpb.ReadClientResponse.prototype.setIdentificationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.accountpb.Identification=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.Identification}
 */
proto.accountpb.ReadClientResponse.prototype.addIdentifications = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.accountpb.Identification, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.ReadClientResponse} returns this
 */
proto.accountpb.ReadClientResponse.prototype.clearIdentificationsList = function() {
  return this.setIdentificationsList([]);
};


/**
 * repeated Note notes = 6;
 * @return {!Array<!proto.accountpb.Note>}
 */
proto.accountpb.ReadClientResponse.prototype.getNotesList = function() {
  return /** @type{!Array<!proto.accountpb.Note>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_accountpb_note_pb.Note, 6));
};


/**
 * @param {!Array<!proto.accountpb.Note>} value
 * @return {!proto.accountpb.ReadClientResponse} returns this
*/
proto.accountpb.ReadClientResponse.prototype.setNotesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.accountpb.Note=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.Note}
 */
proto.accountpb.ReadClientResponse.prototype.addNotes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.accountpb.Note, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.ReadClientResponse} returns this
 */
proto.accountpb.ReadClientResponse.prototype.clearNotesList = function() {
  return this.setNotesList([]);
};


/**
 * repeated SubAccount sub_accounts = 7;
 * @return {!Array<!proto.accountpb.SubAccount>}
 */
proto.accountpb.ReadClientResponse.prototype.getSubAccountsList = function() {
  return /** @type{!Array<!proto.accountpb.SubAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto_accountpb_subaccount_pb.SubAccount, 7));
};


/**
 * @param {!Array<!proto.accountpb.SubAccount>} value
 * @return {!proto.accountpb.ReadClientResponse} returns this
*/
proto.accountpb.ReadClientResponse.prototype.setSubAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.accountpb.SubAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.SubAccount}
 */
proto.accountpb.ReadClientResponse.prototype.addSubAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.accountpb.SubAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.ReadClientResponse} returns this
 */
proto.accountpb.ReadClientResponse.prototype.clearSubAccountsList = function() {
  return this.setSubAccountsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.UpdateClientResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.UpdateClientResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.UpdateClientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.UpdateClientResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    client: (f = msg.getClient()) && proto.accountpb.Client.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.UpdateClientResponse}
 */
proto.accountpb.UpdateClientResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.UpdateClientResponse;
  return proto.accountpb.UpdateClientResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.UpdateClientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.UpdateClientResponse}
 */
proto.accountpb.UpdateClientResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountpb.Client;
      reader.readMessage(value,proto.accountpb.Client.deserializeBinaryFromReader);
      msg.setClient(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.UpdateClientResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.UpdateClientResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.UpdateClientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.UpdateClientResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClient();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.accountpb.Client.serializeBinaryToWriter
    );
  }
};


/**
 * optional Client client = 1;
 * @return {?proto.accountpb.Client}
 */
proto.accountpb.UpdateClientResponse.prototype.getClient = function() {
  return /** @type{?proto.accountpb.Client} */ (
    jspb.Message.getWrapperField(this, proto.accountpb.Client, 1));
};


/**
 * @param {?proto.accountpb.Client|undefined} value
 * @return {!proto.accountpb.UpdateClientResponse} returns this
*/
proto.accountpb.UpdateClientResponse.prototype.setClient = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.UpdateClientResponse} returns this
 */
proto.accountpb.UpdateClientResponse.prototype.clearClient = function() {
  return this.setClient(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.UpdateClientResponse.prototype.hasClient = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.GetAccountIdResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.GetAccountIdResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.GetAccountIdResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.GetAccountIdResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.GetAccountIdResponse}
 */
proto.accountpb.GetAccountIdResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.GetAccountIdResponse;
  return proto.accountpb.GetAccountIdResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.GetAccountIdResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.GetAccountIdResponse}
 */
proto.accountpb.GetAccountIdResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.GetAccountIdResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.GetAccountIdResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.GetAccountIdResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.GetAccountIdResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.accountpb.GetAccountIdResponse.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.GetAccountIdResponse} returns this
 */
proto.accountpb.GetAccountIdResponse.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.ListClientRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.ListClientRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.ListClientRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ListClientRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    correspondent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 6, ""),
    status: jspb.Message.getFieldWithDefault(msg, 7, ""),
    broker: jspb.Message.getFieldWithDefault(msg, 8, ""),
    usrId: jspb.Message.getFieldWithDefault(msg, 9, 0),
    pagination: (f = msg.getPagination()) && proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.ListClientRequest}
 */
proto.accountpb.ListClientRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.ListClientRequest;
  return proto.accountpb.ListClientRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.ListClientRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.ListClientRequest}
 */
proto.accountpb.ListClientRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUsrId(value);
      break;
    case 16:
      var value = new proto_utilspb_pagination_pb.Pagination;
      reader.readMessage(value,proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.ListClientRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.ListClientRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.ListClientRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ListClientRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getUsrId();
  if (f !== 0) {
    writer.writeUint32(
      9,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
};


/**
 * optional string correspondent = 1;
 * @return {string}
 */
proto.accountpb.ListClientRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.ListClientRequest} returns this
 */
proto.accountpb.ListClientRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string branch = 2;
 * @return {string}
 */
proto.accountpb.ListClientRequest.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.ListClientRequest} returns this
 */
proto.accountpb.ListClientRequest.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_no = 3;
 * @return {string}
 */
proto.accountpb.ListClientRequest.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.ListClientRequest} returns this
 */
proto.accountpb.ListClientRequest.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_name = 4;
 * @return {string}
 */
proto.accountpb.ListClientRequest.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.ListClientRequest} returns this
 */
proto.accountpb.ListClientRequest.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string master_account_no = 5;
 * @return {string}
 */
proto.accountpb.ListClientRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.ListClientRequest} returns this
 */
proto.accountpb.ListClientRequest.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string rep = 6;
 * @return {string}
 */
proto.accountpb.ListClientRequest.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.ListClientRequest} returns this
 */
proto.accountpb.ListClientRequest.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string status = 7;
 * @return {string}
 */
proto.accountpb.ListClientRequest.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.ListClientRequest} returns this
 */
proto.accountpb.ListClientRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string broker = 8;
 * @return {string}
 */
proto.accountpb.ListClientRequest.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.ListClientRequest} returns this
 */
proto.accountpb.ListClientRequest.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional uint32 usr_id = 9;
 * @return {number}
 */
proto.accountpb.ListClientRequest.prototype.getUsrId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.ListClientRequest} returns this
 */
proto.accountpb.ListClientRequest.prototype.setUsrId = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional utilspb.Pagination pagination = 16;
 * @return {?proto.utilspb.Pagination}
 */
proto.accountpb.ListClientRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (
    jspb.Message.getWrapperField(this, proto_utilspb_pagination_pb.Pagination, 16));
};


/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.accountpb.ListClientRequest} returns this
*/
proto.accountpb.ListClientRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.accountpb.ListClientRequest} returns this
 */
proto.accountpb.ListClientRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.accountpb.ListClientRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 16) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountpb.ListClientResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.ListClientResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.ListClientResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.ListClientResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ListClientResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    clientsList: jspb.Message.toObjectList(msg.getClientsList(),
    proto.accountpb.Client.toObject, includeInstance),
    totalRows: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.ListClientResponse}
 */
proto.accountpb.ListClientResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.ListClientResponse;
  return proto.accountpb.ListClientResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.ListClientResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.ListClientResponse}
 */
proto.accountpb.ListClientResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountpb.Client;
      reader.readMessage(value,proto.accountpb.Client.deserializeBinaryFromReader);
      msg.addClients(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalRows(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.ListClientResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.ListClientResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.ListClientResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ListClientResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getClientsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountpb.Client.serializeBinaryToWriter
    );
  }
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
};


/**
 * repeated Client clients = 1;
 * @return {!Array<!proto.accountpb.Client>}
 */
proto.accountpb.ListClientResponse.prototype.getClientsList = function() {
  return /** @type{!Array<!proto.accountpb.Client>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountpb.Client, 1));
};


/**
 * @param {!Array<!proto.accountpb.Client>} value
 * @return {!proto.accountpb.ListClientResponse} returns this
*/
proto.accountpb.ListClientResponse.prototype.setClientsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountpb.Client=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.Client}
 */
proto.accountpb.ListClientResponse.prototype.addClients = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountpb.Client, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.ListClientResponse} returns this
 */
proto.accountpb.ListClientResponse.prototype.clearClientsList = function() {
  return this.setClientsList([]);
};


/**
 * optional uint32 total_rows = 2;
 * @return {number}
 */
proto.accountpb.ListClientResponse.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.ListClientResponse} returns this
 */
proto.accountpb.ListClientResponse.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.EmptyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.EmptyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.EmptyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.EmptyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.EmptyRequest}
 */
proto.accountpb.EmptyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.EmptyRequest;
  return proto.accountpb.EmptyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.EmptyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.EmptyRequest}
 */
proto.accountpb.EmptyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.EmptyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.EmptyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.EmptyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.EmptyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.SelectionItem.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.SelectionItem.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.SelectionItem} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.SelectionItem.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.SelectionItem}
 */
proto.accountpb.SelectionItem.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.SelectionItem;
  return proto.accountpb.SelectionItem.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.SelectionItem} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.SelectionItem}
 */
proto.accountpb.SelectionItem.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.SelectionItem.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.SelectionItem.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.SelectionItem} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.SelectionItem.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.accountpb.SelectionItem.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.SelectionItem} returns this
 */
proto.accountpb.SelectionItem.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.accountpb.SelectionItem.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.SelectionItem} returns this
 */
proto.accountpb.SelectionItem.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.accountpb.ListSelectionItemResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.ListSelectionItemResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.ListSelectionItemResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.ListSelectionItemResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ListSelectionItemResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    itemsList: jspb.Message.toObjectList(msg.getItemsList(),
    proto.accountpb.SelectionItem.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.ListSelectionItemResponse}
 */
proto.accountpb.ListSelectionItemResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.ListSelectionItemResponse;
  return proto.accountpb.ListSelectionItemResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.ListSelectionItemResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.ListSelectionItemResponse}
 */
proto.accountpb.ListSelectionItemResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.accountpb.SelectionItem;
      reader.readMessage(value,proto.accountpb.SelectionItem.deserializeBinaryFromReader);
      msg.addItems(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.ListSelectionItemResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.ListSelectionItemResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.ListSelectionItemResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ListSelectionItemResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getItemsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.accountpb.SelectionItem.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SelectionItem items = 1;
 * @return {!Array<!proto.accountpb.SelectionItem>}
 */
proto.accountpb.ListSelectionItemResponse.prototype.getItemsList = function() {
  return /** @type{!Array<!proto.accountpb.SelectionItem>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.accountpb.SelectionItem, 1));
};


/**
 * @param {!Array<!proto.accountpb.SelectionItem>} value
 * @return {!proto.accountpb.ListSelectionItemResponse} returns this
*/
proto.accountpb.ListSelectionItemResponse.prototype.setItemsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.accountpb.SelectionItem=} opt_value
 * @param {number=} opt_index
 * @return {!proto.accountpb.SelectionItem}
 */
proto.accountpb.ListSelectionItemResponse.prototype.addItems = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.accountpb.SelectionItem, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.accountpb.ListSelectionItemResponse} returns this
 */
proto.accountpb.ListSelectionItemResponse.prototype.clearItemsList = function() {
  return this.setItemsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.ListSubAccountTypeItemRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.ListSubAccountTypeItemRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.ListSubAccountTypeItemRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ListSubAccountTypeItemRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountType: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.ListSubAccountTypeItemRequest}
 */
proto.accountpb.ListSubAccountTypeItemRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.ListSubAccountTypeItemRequest;
  return proto.accountpb.ListSubAccountTypeItemRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.ListSubAccountTypeItemRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.ListSubAccountTypeItemRequest}
 */
proto.accountpb.ListSubAccountTypeItemRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.ListSubAccountTypeItemRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.ListSubAccountTypeItemRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.ListSubAccountTypeItemRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.ListSubAccountTypeItemRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string account_type = 1;
 * @return {string}
 */
proto.accountpb.ListSubAccountTypeItemRequest.prototype.getAccountType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.ListSubAccountTypeItemRequest} returns this
 */
proto.accountpb.ListSubAccountTypeItemRequest.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.GetAccountInfoRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.GetAccountInfoRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.GetAccountInfoRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.GetAccountInfoRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.GetAccountInfoRequest}
 */
proto.accountpb.GetAccountInfoRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.GetAccountInfoRequest;
  return proto.accountpb.GetAccountInfoRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.GetAccountInfoRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.GetAccountInfoRequest}
 */
proto.accountpb.GetAccountInfoRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.GetAccountInfoRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.GetAccountInfoRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.GetAccountInfoRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.GetAccountInfoRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.GetAccountInfoResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.GetAccountInfoResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.GetAccountInfoResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.GetAccountInfoResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountNo: jspb.Message.getFieldWithDefault(msg, 1, ""),
    correspondent: jspb.Message.getFieldWithDefault(msg, 2, ""),
    status: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.GetAccountInfoResponse}
 */
proto.accountpb.GetAccountInfoResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.GetAccountInfoResponse;
  return proto.accountpb.GetAccountInfoResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.GetAccountInfoResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.GetAccountInfoResponse}
 */
proto.accountpb.GetAccountInfoResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.GetAccountInfoResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.GetAccountInfoResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.GetAccountInfoResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.GetAccountInfoResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string account_no = 1;
 * @return {string}
 */
proto.accountpb.GetAccountInfoResponse.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.GetAccountInfoResponse} returns this
 */
proto.accountpb.GetAccountInfoResponse.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string correspondent = 2;
 * @return {string}
 */
proto.accountpb.GetAccountInfoResponse.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.GetAccountInfoResponse} returns this
 */
proto.accountpb.GetAccountInfoResponse.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string status = 3;
 * @return {string}
 */
proto.accountpb.GetAccountInfoResponse.prototype.getStatus = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.accountpb.GetAccountInfoResponse} returns this
 */
proto.accountpb.GetAccountInfoResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.accountpb.GetUserAccountIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.accountpb.GetUserAccountIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.accountpb.GetUserAccountIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.GetUserAccountIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.accountpb.GetUserAccountIdRequest}
 */
proto.accountpb.GetUserAccountIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.accountpb.GetUserAccountIdRequest;
  return proto.accountpb.GetUserAccountIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.accountpb.GetUserAccountIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.accountpb.GetUserAccountIdRequest}
 */
proto.accountpb.GetUserAccountIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.accountpb.GetUserAccountIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.accountpb.GetUserAccountIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.accountpb.GetUserAccountIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.accountpb.GetUserAccountIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.accountpb.GetUserAccountIdRequest.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.accountpb.GetUserAccountIdRequest} returns this
 */
proto.accountpb.GetUserAccountIdRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


goog.object.extend(exports, proto.accountpb);
